var modules_28f16a69 = {"avatar":"_nwsx3a","size-20":"_h7yr1q","size-28":"_ibocn4","size-36":"_1q5gtec","size-44":"_12qenx4","size-52":"_6bvl9m","size-60":"_13ij31x","image":"_pve7mh","group":"_f9jqts"};
import "../../../assets/Cywlzo1a.css";

export { modules_28f16a69 as default };
//# sourceMappingURL=Avatar.module.less.js.map
